import { Screen } from '~/screens/StressAssessments';

export const StressAssessments: React.FC = () => {
  return <Screen />;
};
